// This file is automatically generated from ingestAssets.mjs
import * as React from 'react';
import IconContainer, { IconProps } from '../../../components/IconContainer';

export function UserCircleGearBoldIcon(props: IconProps) {
	return (
		<IconContainer {...props}>
			{
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="100%"
					height="100%"
					fill="none"
					viewBox="0 0 32 32"
				>
					<path
						fill="currentColor"
						d="M21.196 5.764a1.5 1.5 0 0 1 1.89-.963l.414.134V4.5a1.5 1.5 0 1 1 3 0v.435l.414-.134a1.5 1.5 0 1 1 .927 2.853l-.414.135.25.352a1.5 1.5 0 1 1-2.426 1.763L25 9.553l-.25.35a1.5 1.5 0 1 1-2.426-1.762l.25-.352-.414-.135a1.5 1.5 0 0 1-.964-1.89ZM29.5 16A13.5 13.5 0 1 1 18.25 2.686a1.5 1.5 0 1 1-.5 2.959A10.624 10.624 0 0 0 16 5.5a10.493 10.493 0 0 0-8.244 16.992 10.434 10.434 0 0 1 3.625-2.927 6.5 6.5 0 1 1 9.25 0c1.414.69 2.653 1.69 3.625 2.927A10.446 10.446 0 0 0 26.5 16c0-.586-.049-1.172-.145-1.75a1.5 1.5 0 0 1 2.959-.5c.124.744.186 1.496.186 2.25ZM16 18.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Zm0 8c2.17.002 4.285-.673 6.054-1.929a7.5 7.5 0 0 0-12.108 0A10.441 10.441 0 0 0 16 26.5Z"
					/>
				</svg>
			}
		</IconContainer>
	);
}
